import '../style/checkbox-C1Sk1qe8.css'
import { defineComponent as E, useSlots as w, toRefs as S, computed as k, openBlock as d, createElementBlock as m, unref as n, normalizeClass as v, withModifiers as V, withKeys as B, createElementVNode as z, renderSlot as M, createTextVNode as N, toDisplayString as I, createCommentVNode as P, reactive as T, watch as g, Fragment as U, renderList as $, createBlock as A } from "vue";
import { useFormItem as y } from "./hooks/useFormItem.js";
import { UPDATE_MODEL_VALUE as p } from "./constant/events.js";
import { useElementId as D } from "./hooks/useElementId.js";
import { useComponentClassList as K } from "./hooks/useComponentClassList.js";
import { useInputSize as O } from "./hooks/useInputSize.js";
const F = ["id", "aria-label", "for", "aria-checked", "onKeydown"], G = ["id", "aria-disabled"], R = /* @__PURE__ */ z("span", { class: "e-checkbox__tick" }, null, -1), j = [
  R
], q = {
  key: 0,
  class: "e-checkbox__text"
}, C = "e-checkbox", H = /* @__PURE__ */ E({
  name: C,
  __name: "checkbox",
  props: {
    modelValue: { type: Boolean },
    value: {},
    text: {},
    name: {},
    disabled: { type: Boolean },
    size: {},
    validateEvent: { type: Boolean, default: !0 },
    textPosition: { default: "right" }
  },
  emits: [p],
  setup(h, { emit: f }) {
    const t = h, _ = f, { elementId: i } = D("checkbox"), u = w(), { formItem: c, formSize: b } = y(), { size: o, disabled: s } = S(t), { actualSize: e } = O({ formSize: b, propSize: o }), a = K(C, {
      size: e,
      disabled: s
    }), r = k(() => t.text || u.default), L = k(() => {
      const l = r.value ? [`e-checkbox--${t.textPosition}`, "e-checkbox--has-text"] : [];
      return [...a.value, l];
    });
    function x() {
      if (s.value) return;
      const l = !t.modelValue;
      _(p, l, t.value), t.validateEvent && c.validate?.("change");
    }
    return (l, Q) => (d(), m("label", {
      id: n(c).formItemId,
      "aria-label": n(c).label,
      class: v(L.value),
      role: "checkbox",
      tabindex: "0",
      for: n(i),
      "aria-checked": l.modelValue,
      onClick: V(x, ["stop"]),
      onKeydown: B(V(x, ["stop", "prevent"]), ["space", "enter"])
    }, [
      z("span", {
        id: n(i),
        "aria-disabled": n(s),
        class: v(["e-checkbox__check", { "e-checkbox__check--checked": l.modelValue }])
      }, j, 10, G),
      r.value ? (d(), m("span", q, [
        M(l.$slots, "default", {}, () => [
          N(I(l.text), 1)
        ])
      ])) : P("", !0)
    ], 42, F));
  }
}), J = ["id", "aria-label"], oe = /* @__PURE__ */ E({
  name: "e-checkbox-group",
  __name: "checkbox-group",
  props: {
    items: {},
    modelValue: {}
  },
  emits: [p],
  setup(h, { emit: f }) {
    const t = h, _ = f, i = T({}), { formItem: u } = y();
    g(() => t.items, (o) => {
      c(o, t.modelValue);
    }, { immediate: !0 }), g(() => t.modelValue, (o) => {
      c(t.items, o);
    });
    function c(o, s) {
      o.forEach((e, a) => {
        i[a] = s.includes(e.value);
      });
    }
    function b(o, s) {
      const e = [...t.modelValue];
      if (o)
        e.push(s);
      else {
        const a = t.modelValue.findIndex((r) => r === s);
        a > -1 && e.splice(a, 1);
      }
      _(p, e);
    }
    return (o, s) => (d(), m("div", {
      id: n(u).formItemId,
      class: "e-checkbox-group",
      role: "group",
      "aria-label": n(u).label ?? "checkbox-group"
    }, [
      (d(!0), m(U, null, $(o.items, (e, a) => (d(), A(H, {
        key: a,
        modelValue: i[a],
        "onUpdate:modelValue": [(r) => i[a] = r, b],
        value: e.value,
        text: e.text,
        name: e.name,
        disabled: e.disabled,
        "text-position": e.textPosition,
        size: e.size,
        "validate-event": e.validateEvent
      }, null, 8, ["modelValue", "onUpdate:modelValue", "value", "text", "name", "disabled", "text-position", "size", "validate-event"]))), 128))
    ], 8, J));
  }
});
export {
  H as Checkbox,
  oe as CheckboxGroup
};
//# sourceMappingURL=checkbox.js.map
